import $ from 'jquery';

export class Faqs {

	_qnaListBtn;

	/**
	 * Constructor.
	 *
	 * @return {void}
	 */
	constructor() {

		const bodyEl = $( 'body' );

		// If its not faq page template, return.
		if ( ! bodyEl.hasClass( 'page-template-faq' ) && ! bodyEl.hasClass( 'page-template-default' ) ) {
			return;
		}

		this.qnaListBtn = $( '.qna-list__btn' );
		if ( ! this.qnaListBtn ) {
			return;
		}

		this.addEvents();
	}

	addEvents() {
		this.qnaListBtn.on( 'click', ( event ) => this.toggleQnaContent( event ) )
	}

	toggleQnaContent( event ) {

		const targetEl = $( event.target );
		const btnEl = targetEl.hasClass( 'qna-list__btn' ) ? targetEl : targetEl.parent();

		if ( ! btnEl.parent().hasClass( 'is-open' ) ) {
			btnEl.next().stop().slideDown(300);
		} else {
			btnEl.next().stop().slideUp(300);
		}

		btnEl.parent().toggleClass( 'is-open' );

	}

	set qnaListBtn( value ) {
		this._qnaListBtn = value;
	}

	get qnaListBtn() {
		return this._qnaListBtn;
	}

}

